import React from "react";
import LoginPage from "./loginPage";
import { useHistory } from "react-router-dom";
var isHasValidSession =
  JSON.parse(
    JSON.parse(localStorage.getItem("persist:root") ?? "{}")?.userAccess ?? "{}"
  )?.token?.length > 0 ?? false;

isHasValidSession === false && localStorage.clear();
const Index = props => {
  return <LoginPage {...props}></LoginPage>;
};

export default Index;
